import { useCookies } from "react-cookie";
import { useState } from "react";
import { toast } from "react-toastify";
import * as Comp from "../../../common/CommonComponents";
import * as common from "../../../common/common";
import http from "../../../common/http-common";

const RoleDelete = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const message = (
    <>
      Confirm to delete?
      <br />
      Role Name:
      {<b>{props.editData !== null && props.editData.ROLE_NAME}</b>}
    </>
  );

  const hideModal = () => {
    props.onHide();
  };

  const deleteBtnOnClick = () => {
    RemoveRole(props.editData);
  };

  const RemoveRole = (_data) => {
    let functionName = "";

    try {
      functionName = props.page + RemoveRole.name;

      props.onLoading(true, "Deleting role, please wait...");
      props.onHide();

      const data = {
        ROLE_ID: _data.ROLE_ID,
        ROLE_NAME: _data.ROLE_NAME,
        UPDATE_ID: userId,
        FROM_SOURCE: { SOURCE: "WEB" /*MODULE_ID: props.module*/ },
      };

      http
        .put("api/roles/DeleteRole", data, { timeout: 5000 })
        .then(() => {
          toast.success("Role is successfully deleted.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to delete role. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to delete role. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        onHide={hideModal}
        onConfirm={deleteBtnOnClick}
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default RoleDelete;
